/**
 * /frontend/src/features/analytics/components/staffing/StaffRecommendationChart.js
 */

import React from 'react';
import ChartContainer from '../shared/ChartContainer';
import StackedBarChart from '../charts/StackedBarChart';

/**
 * Recommended staffing schedule (stacked by zone).
 * @param {{data:any[],zoneKeys:string[]}} props
 * @returns {JSX.Element}
 */
const StaffRecommendationChart = ({ data, zoneKeys }) => (
  <ChartContainer title="Recommended Staffing" subtitle="Staff per hour (by zone)">
    <StackedBarChart data={data} xKey="hourLabel" stackKeys={zoneKeys || []} />
  </ChartContainer>
);

export default StaffRecommendationChart;

